var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapper-child"},[_c('img',{attrs:{"width":"350","src":"/assets/img/loader/icon-loader.gif","alt":"لطفا منتظر بمانید","title":"لطفا منتظر بمانید"}})])
}]

export { render, staticRenderFns }